import { SchemaPlugin } from '@common/prosemirror/model/schema-plugin';
import { nodeToDOM } from '@common/util/schema';
import { NodeSpec } from 'prosemirror-model';

export class PreSchemaPlugin extends SchemaPlugin {
  nodes = {
    pre: {
      group: 'block',
      content: 'inline*',
      code: true,
      parseDOM: [{
        tag: 'pre',
        preserveWhitespace: 'full'
      }],
      toDOM(node) { return nodeToDOM(node); }
    }
  } satisfies Record<string, NodeSpec>;
}
